import type { RootState } from 'features/app/store/store';
import { AstSignMailHandoffStatus } from 'features/ast-signmail/interfaces';

export const selectAstSignMailHandoffStatus = ({ astSignMail }: RootState) =>
  astSignMail.handoffStatus;

export const selectIsAstSignMailHandoffActive = (state: RootState) =>
  selectAstSignMailHandoffStatus(state) === AstSignMailHandoffStatus.SHOWING;

/** True while the post-reset queue return notice should stay on screen. */
export const selectIsAstSignMailQueueReturnNoticeVisible = (state: RootState) =>
  state.astSignMail.isQueueReturnNoticeVisible;

/** True while AST owns SignMail destination (ownership transfer or handoff UI). */
export const selectIsAstSignMailDestinationClaimed = (state: RootState) => {
  const handoffStatus = selectAstSignMailHandoffStatus(state);
  return (
    handoffStatus === AstSignMailHandoffStatus.TRANSFERRING ||
    handoffStatus === AstSignMailHandoffStatus.SHOWING
  );
};

export const selectHasAstSignMailHandoffSucceeded = ({
  astSignMail,
}: RootState) => astSignMail.hasHandoffSucceeded;

/**
 * Once ownership succeeds, keep auto-close blocked until the call reset even
 * if the presentation status changes before final local cleanup completes.
 */
export const selectShouldBlockAstSignMailAutoClose = (state: RootState) =>
  selectIsAstSignMailDestinationClaimed(state) ||
  selectHasAstSignMailHandoffSucceeded(state);

export const selectAstSignMailMode = ({ astSignMail }: RootState) =>
  astSignMail.astSignMailMode;

export const selectTextOnSignMail = ({ astSignMail }: RootState) =>
  astSignMail.textOnSignMail;

export const selectTransferAstRelayResponse = ({ astSignMail }: RootState) =>
  astSignMail.transferAstRelayResponse;
